import { useContext, useMemo } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { INexudusCoworker } from '@portal/env/services/nexudus/types/Coworker';

/**
 * Hook to access auth store data needed for checkout.
 *
 * IMPORTANT: Components using this hook must be wrapped with MobX `observer()`
 * to react to observable changes.
 */
export function useAuth() {
  const stores = useContext(MobXProviderContext) as Record<string, any>;

  if (!stores?.authStore) {
    throw new Error('useAuth must be used within a MobX Provider');
  }

  const store = stores.authStore;

  const actions = useMemo(
    () => ({
      loadMe: store.loadMe as () => Promise<{ AccessToken: string }>,
    }),
    [store],
  );

  return {
    isLoggedIn: store.isLoggedIn as boolean,
    actions,
    accessToken: store.accessToken as string,
    host: store.host as string,
    customer: store.customer as INexudusCoworker | null,
  };
}
